exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table-view thead[data-v-46c0b994]{display:table-header-group}.table-view td[data-v-46c0b994]{text-align:center}.report-photo[data-v-46c0b994]{width:100px;display:inline-block}.report-photo img[data-v-46c0b994]{width:100%}.report-photo+.report-photo[data-v-46c0b994]{margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46c0b994","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Content/src/views/Reports.vue
// module id = 637
// module chunks = 1